var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-layout",
    {
      staticClass: "vs-tabs",
      class: {
        "vs-tabs--border": _vm.showBorder,
        "vs-tabs--padding": _vm.padding
      },
      attrs: {
        "wrap-xs": "wrap-xs",
        "horz-align-center-xs": "horz-align-center-xs",
        role: "tablist"
      }
    },
    _vm._l(_vm.tabs, function(tab, index) {
      return _c(
        "vs-layout",
        {
          key: tab.text,
          staticClass: "vs-tab",
          class: _vm.classes(tab),
          attrs: {
            id: _vm.getAriaTabIdFromBase(index),
            "auto-xs": "auto-xs",
            "no-gutter": "no-gutter",
            "horz-align-center-xs": "horz-align-center-xs",
            "vert-align-center-xs": "vert-align-center-xs",
            tabindex: "0",
            role: "tab",
            "aria-selected": _vm.isSelected(tab)
          },
          nativeOn: {
            click: function($event) {
              return _vm.handleClick(tab)
            },
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.handleClick(tab)
            }
          }
        },
        [_c("span", [_vm._v(_vm._s(typeof tab === "object" ? tab.text : tab))])]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }